import { AnyAction } from '@reduxjs/toolkit';

const actionTypePendingGuard = (action: AnyAction) =>
  action.type.endsWith('/pending');

export default actionTypePendingGuard;
